"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GramPerPoundLb = exports.GrainPerPoundLb = exports.PoundLbPerPoundLb = exports.GramPerKilogram = exports.KilogramPerKilogram = void 0;
var uom_1 = require("uom");
exports.KilogramPerKilogram = uom_1.UnitFormat.createUnitFormat("kg/kg", 2);
exports.GramPerKilogram = uom_1.UnitFormat.createUnitFormat("g/kg", 2);
exports.PoundLbPerPoundLb = uom_1.UnitFormat.createUnitFormat("lb/lb", 2);
exports.GrainPerPoundLb = uom_1.UnitFormat.createUnitFormat("gr/lb", 1);
exports.GramPerPoundLb = uom_1.UnitFormat.createUnitFormat("g/lb", 1);
//# sourceMappingURL=humidity-ratio-format.js.map